import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors, dimensions, helpers } from "@styles";

const flexBaseLine = css`
  align-items: baseline;
  display: flex;
`;

export const wrapText = css`
  flex-wrap: wrap;
`;

export const productUnitPricingPromotion = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
  }
`;

const stackedOnMobile = css`
  @media (max-width: ${dimensions.phoneSmallMax}) {
    flex-direction: column;
  }
`;

export const productUnitPricing = isStackedOnMobile => {
  return css`
    ${helpers.ellipsesOverflowHelper}
    ${flexBaseLine}
    ${isStackedOnMobile && stackedOnMobile}
  `;
};

export const stacked = css`
  flex-direction: column;
`;

export const unit = css`
  margin-left: 0.25rem;
`;

export const wholesalePrice = css`
  font-size: 1.25rem;
  color: ${colors.blue.darkFamily.light};
  font-weight: ${typography.weightSemiBold};
`;

export const unitMobile = css`
  ${unit};

  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 0;
  }
`;

export const mobilePrice = css`
  ${flexBaseLine}
  ${wrapText}
`;
